import { categoryAction } from './category.slice';
import {
  getcategoriesApi,
  getQuestionsByIdApi,
  getYearsApi,
  questionnaireNamesApi,
  clientNamesApi
} from 'utils/apis';
import { STATUS_CODE } from 'common/constants';

export const fetchCategories = () => async (dispatch) => {
  try {
    dispatch(categoryAction.getCategoryList());
    const response = await getcategoriesApi();
    // console.log('response.status', response.status);
    if (response.status === STATUS_CODE.Ok) {
      dispatch(categoryAction.setCategories(response.data.data));
    }
  } catch (err) {
    dispatch(categoryAction.stopLoading());
  }
};
export const fetchYears = () => async (dispatch) => {
  try {
    dispatch(categoryAction.getCategoryList());
    const response = await getYearsApi();
    // console.log('response.status', response.status);
    if (response.status === STATUS_CODE.Ok) {
      dispatch(categoryAction.setYears(response.data.data));
    }
  } catch (err) {
    dispatch(categoryAction.stopLoading());
  }
};
export const fetchquestionnaireNames = (payload) => async (dispatch) => {
  try {
    dispatch(categoryAction.getQuestionList());
    const response = await questionnaireNamesApi(payload);
    if (response.status === STATUS_CODE.Ok) {
      dispatch(categoryAction.setQuestionnaireNames(response.data.data));
    }
  } catch (err) {
    dispatch(categoryAction.stopQuesLoading());
  }
};
export const fetchclientNames = (payload) => async (dispatch) => {
  try {
    dispatch(categoryAction.getClientList());
    const response = await clientNamesApi(payload);
    if (response.status === STATUS_CODE.Ok) {
      dispatch(categoryAction.setClientNames(response.data.data));
    }
  } catch (err) {
    dispatch(categoryAction.stopClientLoading());
  }
};
export const fetchgetQuestionsById = (payload) => async (dispatch) => {
  try {
    dispatch(categoryAction.getQuestionList());
    const response = await getQuestionsByIdApi(payload);
    if (response.status === STATUS_CODE.Ok) {
      dispatch(categoryAction.setQuestionData(response.data.data));
    }
  } catch (err) {
    dispatch(categoryAction.stopQuesLoading());
  }
};

export const handleCategoriesSelection = (selectedval) => async (dispatch) => {
  dispatch(categoryAction.setSelectedCategories(selectedval));
};

export const emptyQuestionbyId = () => async (dispatch) => {
  dispatch(categoryAction.emptyQuestionData());
};
